import React, { Component } from 'react';
import { Form, Input, Modal } from 'antd';

const FormItem = Form.Item;

class Manage extends Component {
  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleOk(values);
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      handleCancel,
      confirmLoading,
    } = this.props;
    return (
      <Modal
        title="开票审核"
        visible={visible}
        okText="通过"
        onOk={this.handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => handleCancel(false)}
      >
        <Form>
          <FormItem label="发票号码">
            {getFieldDecorator('codeNo', {
              rules: [{ required: true, message: '请填写发票号码' }],
            })(<Input />)}
          </FormItem>
          <FormItem label="领票人">
            {getFieldDecorator('receiver', {
              rules: [{ required: true, message: '请填写领票人' }],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/invoice/ModalInvoice.js